import { Link } from "react-router-dom";
import { ArrowLeft, Phone } from "lucide-react";
import SmoothScroll from "@/components/site/SmoothScroll";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Seo from "@/components/site/Seo";
import { CONTACT } from "@/data/content";

export default function NotFound() {
  return (
    <SmoothScroll>
      <Seo
        pageKey="home"
        noindex
        overrideTitle="Page not found | Perth Tiling WA"
        overrideDescription="Sorry, that page could not be found. Explore our tiling services or get a free quote."
      />
      <div className="grain-overlay" aria-hidden />
      <div data-testid="not-found-page" className="bg-[#f8fafc] min-h-screen flex flex-col">
        <Navbar />
        <section className="flex-1 flex items-center">
          <div className="mx-auto max-w-[1000px] w-full px-6 md:px-12 py-40 text-center">
            <p className="overline !text-[#9c7a4d] mb-6">Error 404</p>
            <h1 className="font-serif font-light text-[#0f172a] text-5xl sm:text-7xl leading-[0.95] tracking-tight mb-8">
              This page isn't here.
            </h1>
            <p className="text-[#475569] text-lg font-light leading-relaxed max-w-xl mx-auto mb-12">
              The page you were looking for may have moved or no longer exists. Let's get you back to
              something beautiful — explore our tiling work or request a free quote.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <Link
                to="/"
                data-testid="not-found-home-cta"
                className="group inline-flex items-center gap-3 bg-[#9c7a4d] text-white hover:bg-[#0f172a] px-8 py-4 text-xs uppercase tracking-[0.22em] transition-colors"
              >
                <ArrowLeft className="h-4 w-4 group-hover:-translate-x-1 transition-transform" /> Back to home
              </Link>
              <a
                href={`tel:${CONTACT.phoneRaw}`}
                className="inline-flex items-center gap-3 border border-[#0f172a]/20 text-[#0f172a] hover:border-[#9c7a4d] hover:text-[#9c7a4d] px-8 py-4 text-xs uppercase tracking-[0.22em] transition-colors"
              >
                <Phone className="h-4 w-4" /> {CONTACT.phone}
              </a>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
